import { Auth0Authentication } from "../../explorer/components/Authentication/Auth0Authentication";
import Auth0Logout from "../../explorer/components/Authentication/Auth0Logout";
import { AppProfilePopup } from "../components/AppLayout/AppHeader/AppProfile/AppProfilePopup";
import CustomerSiteSelector from "../components/AppLayout/AppHeader/AppSiteSelector/CustomerSiteSelector";

export const AppSiteSelector: React.FC = CustomerSiteSelector;
export const AppProfile: React.FC = AppProfilePopup;
export const AppAuthentication: React.FC<React.PropsWithChildren<any>> =
  Auth0Authentication;
export const AppLogout: React.FC<React.PropsWithChildren<any>> = Auth0Logout;
